'use client';

import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import { useStyles } from './style';
import ActionCTA from '../shared/sweepr-action-cta/ActionCTA';
import { getBannerImage } from './banner.util';

/**
 * @name Banner - Banner component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns Banner Element
 */
const Banner = props => {
  const theme = useTheme();
  const { bannerMobile, bannerDesktop, bannerTablet } = getBannerImage(props);
  const style = useStyles(theme, bannerMobile, bannerTablet, bannerDesktop);

  return (
    <Grid container sx={style.bannerContainer}>
      <Grid container maxWidth='lg' sx={style.bannerBoxContainer}>
        <Grid item xs={12} sm={7} md={6} lg={6} sx={style.bannerDetails}>
          <Box sx={style.bannerBox}>
            <Typography variant={props?.secondBanner ? 'h2' : 'h1'} sx={style.bannerTitle}>
              {props.cmsData?.title}
            </Typography>
            {/* TBU subtitle 3 is introduced in theme as apart of accesibility project EDQ-6937 */}
            <Typography sx={style.bannerDescription}>{props.cmsData?.description}</Typography>
            <Box sx={style.bannerCTA}>
              <ActionCTA cta={props?.cmsData?.Banner_CTAs} handleAction={props.handleAction} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

Banner.displayName = 'Banner';
export default Banner;
